export enum EmployeeUserType {
  TAMUEmployee = 0,
  ADUser = 1,
  TTIEmployee = 2,
  TTIEmployeeAndADUser = 3,
  NonTTIEmployee = 4,
  NonTTIEmployeeAndADUser = 5,
  ADUserExpired = 8,
  TTIEmployeeAndADUserAndADUserExpired = 11,
  NonTTIEmployeeAndADUserAndADUserExpired = 13
}
